import React from "react";
import { t } from "i18next";

import { StyledBadge } from "./InputType.styled";

import { InputTypeEnum, InputTypeEnumKeys } from "@type/Input";

interface InputType {
  type: InputTypeEnumKeys;
}

const InputType: React.FC<InputType> = ({ type }) => (
  <StyledBadge type={InputTypeEnum[type]}>{t(InputTypeEnum[type])}</StyledBadge>
);

export default InputType;
